import React, { useState, useEffect } from 'react';
import styled from 'styled-components/macro';
import { useFormatMessage } from 'components/IntlProvider';
import ProjectProgressSubscribable from 'components/Project/Common/ProjectProgress';
import Plan from './Plan';

const SidebarWrap = styled.aside`
  width: 100%;
  color: #253858;
`;

type AbonmentType =
  | '1'
  | '2'
  | '3'
  | 'bexio-basic'
  | 'bexio-advanced'
  | 'bexio-professional';

type PlanProps = {
  name: string;
  fee: number | string;
  features: string[];
  featuresTitle?: string;
  footerNote?: string;
  discountFee: string;
};

interface StatusType {
  value: number;
  display: string;
}

interface Props {
  initialValues?: {
    Babo?: AbonmentType; // Briefieng abonment
    Bdiscount?: string;
    total_fee?: number;
  };
  model?: any;
  withProjectProgress?: boolean;
  status?: StatusType;
}

const SurveyBriefingSidebar = ({
  model,
  withProjectProgress,
  status,
  initialValues,
}: Props) => {
  const [abonment, setAbonment] = useState<AbonmentType>(
    initialValues?.Babo || model.valuesHash.Babo
  );
  const [priceDetails, setPrice] = useState({
    price: initialValues?.total_fee || model.valuesHash.total_fee,
    discount: Number(initialValues?.Bdiscount || model.valuesHash.Bdiscount),
  });

  const t = useFormatMessage();

  useEffect(() => {
    model.onValueChanged.add(({ valuesHash }: any) => {
      const { Babo, total_fee, Bdiscount } = valuesHash;

      setAbonment(Babo);
      setPrice({
        price: total_fee,
        discount: Number(Bdiscount),
      });
    });

    return () => {
      model.onValueChanged.remove();
    };

    // eslint-dsiable-next-line
  }, [model.onValueChanged]);
  const basicPLan = ['1', 'bexio-basic'];
  const advancedPlan = ['2', 'bexio-advanced'];
  const profesionalPlan = ['3', 'bexio-professional'];

  return (
    <SidebarWrap>
      {withProjectProgress && <ProjectProgressSubscribable status={status} />}
      {abonment && basicPLan.includes(abonment) && (
        <Plan
          name={t(
            'project.customerSatisfaction.plans.basic.title',
            'Basic Plan'
          )}
          fee={t(
            'project.customerSatisfaction.plans.fee',
            'CHF{nbsp}{fee}/Month',
            {
              fee: priceDetails.price,
              nbsp: '\u00A0',
            }
          )}
          discountFee={
            priceDetails.discount > 0
              ? t(
                  'project.customerSatisfaction.plans.fee',
                  'CHF{nbsp}{fee}/Month',
                  {
                    fee: priceDetails.price - priceDetails.discount,
                    nbsp: '\u00A0',
                  }
                )
              : null
          }
          featuresTitle={t(
            'project.customerSatisfaction.plans.features.title',
            'Includes'
          )}
          features={[
            `10 ${t(
              'project.customerSatisfaction.plans.features.interviews',
              'interviews per month included*'
            )}`,
            t(
              'project.customerSatisfaction.plans.features.aggregatedResults',
              'Aggregated customer satisfaction results'
            ),
          ]}
        />
      )}

      {abonment && advancedPlan.includes(abonment) && (
        <Plan
          name={t(
            'project.customerSatisfaction.plans.advanced.title',
            'Advanced Plan'
          )}
          fee={t(
            'project.customerSatisfaction.plans.fee',
            'CHF{nbsp}{fee}/Month',
            {
              fee: priceDetails.price,
              nbsp: '\u00A0',
            }
          )}
          discountFee={
            priceDetails.discount > 0
              ? t(
                  'project.customerSatisfaction.plans.fee',
                  'CHF{nbsp}{fee}/Month',
                  {
                    fee: priceDetails.price - priceDetails.discount,
                    nbsp: '\u00A0',
                  }
                )
              : null
          }
          featuresTitle={t(
            'project.customerSatisfaction.plans.features.title',
            'Includes'
          )}
          features={[
            `30 ${t(
              'project.customerSatisfaction.plans.features.interviews',
              'interviews per month included*'
            )}`,
            t(
              'project.customerSatisfaction.plans.features.aggregatedResults',
              'Aggregated customer satisfaction results'
            ),
            t(
              'project.customerSatisfaction.plans.features.detailedResults',
              'Detailed customer satisfaction results'
            ),
          ]}
        />
      )}
      {abonment && profesionalPlan.includes(abonment) && (
        <Plan
          name={t(
            'project.customerSatisfaction.plans.profesional.title',
            'Profesional Plan'
          )}
          fee={t(
            'project.customerSatisfaction.plans.fee',
            'CHF{nbsp}{fee}/Month',
            {
              fee: priceDetails.price,
              nbsp: '\u00A0',
            }
          )}
          discountFee={
            priceDetails.discount > 0
              ? t(
                  'project.customerSatisfaction.plans.fee',
                  'CHF{nbsp}{fee}/Month',
                  {
                    fee: priceDetails.price - priceDetails.discount,
                    nbsp: '\u00A0',
                  }
                )
              : null
          }
          featuresTitle={t(
            'project.customerSatisfaction.plans.features.title',
            'Includes'
          )}
          features={[
            `100 ${t(
              'project.customerSatisfaction.plans.features.interviews',
              'interviews per month included*'
            )}`,
            t(
              'project.customerSatisfaction.plans.features.aggregatedResults',
              'Aggregated customer satisfaction results'
            ),
            t(
              'project.customerSatisfaction.plans.features.detailedResults',
              'Detailed customer satisfaction results'
            ),
            t(
              'project.customerSatisfaction.plans.features.likes',
              'Likes and dislikes'
            ),
            t(
              'project.customerSatisfaction.plans.features.benchmark',
              'Industry benchmark'
            ),
            t(
              'project.customerSatisfaction.plans.features.individulLevel',
              'Results visible on individual level'
            ),
          ]}
        />
      )}
    </SidebarWrap>
  );
};

export default SurveyBriefingSidebar;
